<template>
	<c-dialog ref="dialog" title="确认核销" width="500" @resolve="checkHandle">
		<c-form ref="form" unit-width="100%">
			<c-form-item label="支付金额">
				<c-input name="trade_amount" disabled></c-input>
			</c-form-item>
			<c-form-item label="支付凭证">
				<c-file v-if="payVoucherUrl" :src="payVoucherUrl" media></c-file>
				<span v-else>-</span>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark" maxlength="500" placeholder="请输入备注信息"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
export default {
	name: 'offlinePayCheckDialog',

	data() {
		return {
			unionPayId: 0,
			payVoucherUrl: ''
		}
	},

	methods: {
		/*********打开核销弹窗**********/
		open(data) {
			this.unionPayId = data.union_pay_id;
			this.payVoucherUrl = data.pay_voucher_url || '';
			this.$refs.form.clear();
			this.$refs.form.set({
				trade_amount: this.formatPrice(data.trade_amount),
				remark: data.remark || ''
			});
			this.$refs.dialog.open();
		},

		/*********格式化价格**********/
		formatPrice(price) {
			if (price === null || price === undefined || price === '') return '-';
			return '¥' + parseFloat(price).toFixed(2);
		},

		/******核销提交处理********/
		checkHandle(stop, next) {
			stop();
			this.$refs.form.submit({
				url: '/offline/pay/check/check',
				rule: {},
				dataFormatter: data => {
					data.ids = [this.unionPayId];
					return data;
				},
				success: () => {
					next();
					this.$message({
						message: '核销成功',
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>
